import { createIconSetFromIcoMoon } from "react-native-vector-icons";
import icoMoonConfig from "@fkhplus/common/src/assets/icons/selection.json";

export default createIconSetFromIcoMoon(icoMoonConfig);

export interface IIcons {
  rxGrey: string;
  reorder: string;
  search: string;
  microphone: string;
  trash: string;
  plus: string;
  minus: string;
  prescription: string;
  bell: string;
  camera: string;
  rightArrow: string;
  cart: string;
  info: string;
  arrowDown: string;
  arrowLeft: string;
  circleCurve: string;
  bottomCurve: string;
  sectorCurve: string;
  close: string;
  error:string;
}

export const IconsName: IIcons = {
  rxGrey: "rxGrey",
  reorder: "reorder",
  search: "search",
  microphone: "microphone",
  trash: "trash",
  plus: "plus",
  minus: "minus",
  prescription: "prescription",
  bell: "bell",
  camera: "camera",
  rightArrow: "rightArrow",
  cart: "cart",
  info: "info",
  arrowDown: "arrowDown",
  arrowLeft: "arrowLeft",
  circleCurve: "circleCurve",
  bottomCurve: "bottomCurve",
  sectorCurve: "sectorCurve",
  close: "close",
  error:'error'
};
